/**
 * ชุดคำถามตัวอย่างสำหรับทดสอบ Chat Test โหมด Ask (และบางข้อทดสอบการตีความ)
 * ไม่ได้รันจาก UI โดยอัตโนมัติ — นำไปใช้ manual, script, หรือ Playwright ได้
 */
export const CHAT_TEST_QUESTIONS: string[] = [
  // Roster / ทีม / คำจำกัดความ Employees (1–18)
  'ทีมนี้มีใครบ้าง?',
  'List all agents in this station.',
  'พนักงานในระบบแชทมีกี่คน?',
  'Who are the employees in the Agent Room?',
  'รายชื่อ agent ทั้งหมดของสถานีนี้',
  'มี device type อะไรบ้างใน roster?',
  'แสดง agent_id ของปั๊มทุกตัว',
  'หัวหน้าทีมคือใคร ทำหน้าที่อะไร?',
  'แยกประเภทอุปกรณ์ตาม role ให้หน่อย',
  'ทีมงานในแชทนี้คือ HR หรืออุปกรณ์?',
  'มีกี่ตัวที่เป็น pump_d?',
  'sensor มีกี่ agent?',
  'ใครดูแล powermeter?',
  'รายชื่อสั้นๆ ของทุก device_id',
  'Compare count of pumps vs sensors in the roster.',
  'ใคร active ในรอบนี้?',
  'แสดงโครงสร้างทีมแบบ bullet',
  'มี agent ที่ชื่อคล้าย sp-1 ไหม?',

  // KPI / สถิติ / ภาพรวม (19–36)
  'สรุป KPI ของสถานีนี้',
  'ค่าเฉลี่ยคะแนน KPI ทั้งสถานีเท่าไหร่?',
  'อุปกรณ์ไหนมี KPI สูงสุด?',
  'อุปกรณ์ไหนมี KPI ต่ำสุด?',
  'Top 5 และ Bottom 5 ตาม KPI',
  'สถิติแยกตาม device_type',
  'มีกี่เครื่องที่มี grade A?',
  'trip_score เฉลี่ยของปั๊มเป็นอย่างไร?',
  'runtime balance ดีหรือไม่ โดยรวม?',
  'สรุปภาพรวมสุขภาพของสถานีแบบผู้บริหาร',
  'Give a one-paragraph KPI executive summary.',
  'Which devices need attention based on scores?',
  'kpi_score กับ overall_score ต่างกันยังไง?',
  'มีข้อมูล reporting_period ล่าสุดไหม?',
  'Compare KPI between two arbitrary device types conceptually.',
  'แนวโน้มโดยรวมดีขึ้นหรือแย่ลง? (จากข้อมูลที่มี)',
  'สรุป start_stop metrics แบบสั้นๆ',
  'List devices missing KPI or with null scores.',

  // เจาะประเภท / บทบาท (37–50)
  'เฉพาะปั๊ม สถานะและ KPI เป็นยังไง?',
  'heartbeat agents ทำอะไรในระบบนี้?',
  'flow meter เกี่ยวกับข้อมูลอะไร?',
  'adder กับ mixer ต่างกันอย่างไรในบริบทนี้?',
  'powermeter ควรตอบคำถามเรื่องอะไรได้บ้าง?',
  'All pumps: list device_id only.',
  'Sensors: any outliers in KPI?',
  'Which pump has the best grade?',
  'Describe typical responsibilities of a pump agent.',
  'mixer agents — how many are there?',
  'Manager เลือก target_roles ยังไงจากคำถาม?',
  'คำว่า all ในการเลือก agent หมายถึงอะไร?',
  'MAX_AGENTS_PER_QUERY_PERCENT (โหมด ask) ส่งผลต่อคำตอบอย่างไร?',
  'ข้อมูลอุปกรณ์ผูกกับสถานีอย่างไร?',

  // รหัสอุปกรณ์ / topic (51–64)
  'sp-1 KPI เท่าไหร่?',
  'ej-1 เป็นประเภทอะไร?',
  'อธิบายข้อมูลของอุปกรณ์ sp-24',
  'topic wma/rayong/pump_d/sp-4 หมายถึงอะไร?',
  'ถ้าอ้างถึง sp-99 แต่ไม่มีใน roster จะรู้ได้ยังไง?',
  'แปลงรหัสอุปกรณ์เป็นชื่อที่อ่านง่าย',
  'device_id กับ agent_id ต่างกันยังไง?',
  'หา device ที่มี last_mqtt topic ล่าสุด (ถ้ามีในข้อมูล)',
  'Compare sp-3 and sp-4 if both exist.',
  'อุปกรณ์นี้ online ไหม จากข้อมูลที่มี?',
  'last_start_time ของปั๊มตัวหนึ่งคืออะไร?',
  'total_runtime สูงผิดปกติไหม?',
  'Grade และ grade_description_th ของ ej-10?',
  'มีอุปกรณ์ type pump แต่ id ขึ้นต้นด้วย ej ไหม?',

  // คำถามกว้าง / วิเคราะห์ (65–76)
  'วันนี้ควรโฟกัสที่อุปกรณ์ไหน?',
  'มีความเสี่ยงอะไรจากข้อมูลล่าสุด?',
  'สรุป 3 ประเด็นสำคัญ',
  'What should we tell operations in one sentence?',
  'Any redundancy or duplicate roles in the team?',
  'ข้อมูลไหนน่าไว้ใจที่สุดในระบบนี้?',
  'ถามอะไรก็ได้ที่เกี่ยวกับสถานี — ตอบสั้นๆ',
  'Explain the data pipeline from DB to agent response.',
  'What limits how many agents run per query?',
  'Why might employee discussion be empty sometimes?',
  'roster fast-path ต่างจากการให้ LLM fan-out ทุก agent ยังไง?',
  'กราฟไป FINISH โดยไม่เรียก employees เมื่อไหร่?',

  // คล้ายคำสั่งแต่เป็น Ask (77–86)
  'ถ้าจะสตาร์ทปั๊ม sp-1 ควรเตรียมอะไรบ้าง? (ยังไม่สั่ง)',
  'ปิดปั๊มจะกระทบ KPI อย่างไร?',
  'ขั้นตอนยืนยัน OTP ใช้เมื่อไหร่?',
  'ต่างกันอย่างไรระหว่าง Ask กับ Control?',
  'Preview mode ทำอะไร?',
  'Configure mode เหมาะกับคำถามแบบไหน?',
  'When should I use Master chat vs Station chat?',
  'Can you execute MQTT from Insights mode?',
  'Explain dry_run in one line.',
  'What happens after manager task_assignment?',

  // ภาษา / รูปแบบประโยค (87–94)
  '??? มีกี่ agent',
  'employees??? list pls',
  'KPI ทั้งหมด ขอแบบตารางสั้นๆ',
  'สรุปเป็นภาษาไทยสุภาพหนึ่งย่อหน้า',
  'Short English answer: station overview.',
  'ถามซ้ำ: ทีมมีใคร? (ตอบสั้น)',
  'ขอ JSON-like list ของ device_id',
  'Emojis OK — summarize station health 🟢🟡🔴',

  // Master / multi-station (ใช้เมื่อสลับโหมด Master) (95–100)
  'มีสถานีอะไรบ้างในระบบ?',
  'Compare two stations at a high level (conceptual).',
  'Which station might need the most attention?',
  'Master: route this question to relevant stations only.',
  'สรุปข้ามสถานีแบบ executive (ถ้ามีข้อมูล)',
  'List station IDs from configuration.',
];

export const CHAT_TEST_QUESTION_COUNT = CHAT_TEST_QUESTIONS.length;
